import { atom } from "jotai";
export const etherPadViewerAtom = atom(false);
export const whiteBoardViewerAtom = atom(false);
